import firebase from 'firebase';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';
import { createStore, compose } from 'redux';
import { reactReduxFirebase } from 'react-redux-firebase';
import rootReducer from './reducers/index';

const config = {
  userProfile: 'users', // firebase root where user profiles are stored
  profileParamsToPopulate: ['jobs:jobs', 'school:schools', 'school:schools-data', 'courses:courses'],
};

const firebaseConfig = {
  apiKey: process.env.FIREBASE_SCHOOL_API_KEY,
  authDomain: process.env.FIREBASE_SCHOOL_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_SCHOOL_DATABASE_URL,
  storageBucket: process.env.FIREBASE_SCHOOL_STORAGE_BUCKET,
};

const studentConfig = {
  apiKey: process.env.FIREBASE_STUDENT_API_KEY,
  authDomain: process.env.FIREBASE_STUDENT_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_STUDENT_AUTH_DOMAIN,
  storageBucket: process.env.FIREBASE_STUDENT_AUTH_DOMAIN,
};

firebase.initializeApp(firebaseConfig);

const createStoreWithFirebase = compose(reactReduxFirebase(firebase, config), window.devToolsExtension
  ? window.devToolsExtension()
  : f => f)(createStore);

const store = createStoreWithFirebase(rootReducer, {});

export const studentApp = firebase.initializeApp(studentConfig, 'student');
export const history = syncHistoryWithStore(browserHistory, store);
export default store;



// WEBPACK FOOTER //
// ./src/store.jsx